<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span @click="handleProfit">收益明细</span><i class="el-icon-arrow-right"></i><span>申请提现</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
            <div class="dropdownTitle">
                <div class="titleTop">
                    <p class="currTitle">申请提现</p>
                    <el-button @click="getmyApplyToCash">提现明细</el-button>
                </div>
                
            </div>
            <div class="withdrawal">
                <div class="inputYu">
                    <span>账号余额</span>
                    <p>￥ 9</p>
                </div>
                <div class="inputYu">
                    <span>提现余额</span>
                    <el-input v-model="input" placeholder="请输入填写您要提现到金额"></el-input>
                </div>
                <div>
                    <el-button type="primary">立即提现</el-button>
                </div>
            </div>
           
            
            <div style="text-align: right;">
                <el-pagination
                    :hide-on-single-page="hideOnSinglePage"
                    :page-size="10"
                    :pager-count="widthNew?11:5"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import personalMenu from './index.vue'
export default {
    data(){
        return{
            vsData: [],
            total: 0,
            hideOnSinglePage: true,
            widthNew: false,
            input: ''
        
        }
    },
    components:{
        personalMenu
    },
    methods: {
        listByUser(data){
            this.$store.dispatch('personal/myApplyToCash',data)
            .then(res => {
                if(res.ok){
                    this.total = res.data.total

                    if(this.total <= 10){
                        this.hideOnSinglePage = true
                    }else{
                        this.hideOnSinglePage = false
                    }
                    this.vsData = res.data.items
                   
                }
            })
        },
       
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listSign = {
                vstoken: 'D7FEC3599FA5C0175294E3B57CF76A80',
                vsfrom: 'app',
                mallToken: '',
                pageNo: val,
                pageSize: '10'
    
            }
            this.listByUser(listSign)
        },
        handleProfit(){
            this.$router.go(-1);
            // this.$router.push({
            //     path: '/personal'
            // })
        },
        getmyApplyToCash(){
            this.$router.push({
                path: '/myApplyToCash'
            })
        },
    
    },
    mounted(){
        
       
    },
    created(){
        localStorage.setItem('active','1')
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let listFav = {
            vstoken: 'D7FEC3599FA5C0175294E3B57CF76A80',
            vsfrom: 'app',
            mallToken: '',
            pageNo: '1',
            pageSize: '10'
        }
        // this.listByUser(listFav)
    }
}
</script>

<style scoped lang="scss">
@import url(../../css/personal.css);

.dropdownTitle{
    border-bottom: 0.5px solid #f2f2f2;
    padding:  0 10px 0px 0;
    .titleTop{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .currTitle{
            border: none;
        }
        .el-button{
            border-radius: 50px;
        }
    }
   
}
.withdrawal{
    width: 70%;
    margin: 60px auto;
    .inputYu{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 20px 10px;
        border-bottom: 0.5px solid #f2f2f2;
        color: #333333;
        margin-bottom: 20px;
        span{
            margin-right: 20px;
            font-size: 16px;
            color: #888888;
        }
        .el-input{
            width: 80%;
        }
        ::v-deep .el-input__inner{
            font-size: 18px !important;
            border: none !important;
        }
    }
}
</style>